<template>
    <div class="signature-wrapper d-flex align-items-end">
        <!-- Canvas -->
        <canvas
            ref="signatureCanvas"
            class="flex-grow-1"
            height="120"
            style="border: 1px solid #ced4da; touch-action: none; background-color: transparent;"
        ></canvas>

        <!-- Clear button aligned to bottom -->
        <div class="ml-2 mb-1 flex-shrink-0">
            <!-- <button class="btn btn-primary btn-sm mr-2" @click="saveSignature">Save</button> -->
            <button
                class="btn btn-outline-light btn-sm"
                @click="clearSignature"
                type="button"
            >
                <i class="mdi mdi-restart"></i>
            </button>
        </div>
        <div v-if="signatureData" class="mt-3">
            <strong>Saved Signature:</strong>
            <div class="mt-2">
                <img
                    :src="signatureData"
                    alt="signature"
                    style="border:1px solid #ccc; max-width: 100%;"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SignaturePad",
    data() {
        return {
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            signatureData: null,
            ctx: null,
            hasSignature: false,
        };
    },
    mounted() {
        const canvas = this.$refs.signatureCanvas;
        this.ctx = canvas.getContext("2d");
        this.ctx.strokeStyle = "black";
        this.ctx.lineWidth = 2;
        this.ctx.lineJoin = "round";
        this.ctx.lineCap = "round";

        // Mouse events
        canvas.addEventListener("mousedown", this.startDrawing);
        canvas.addEventListener("mousemove", this.draw);
        canvas.addEventListener("mouseup", this.stopDrawing);
        canvas.addEventListener("mouseout", this.stopDrawing);

        // Touch events
        canvas.addEventListener("touchstart", this.startDrawing);
        canvas.addEventListener("touchmove", this.draw);
        canvas.addEventListener("touchend", this.stopDrawing);
    },
    methods: {
        getPointer(e) {
            const rect = this.$refs.signatureCanvas.getBoundingClientRect();
            const canvas = this.$refs.signatureCanvas;
            if (e.touches && e.touches.length > 0) {
                return {
                    x: (e.touches[0].clientX - rect.left) * canvas.width / rect.width,
                    y: (e.touches[0].clientY - rect.top) * canvas.height / rect.height,
                };
            }
            return {
                x: (e.clientX - rect.left) * canvas.width / rect.width,
                y: (e.clientY - rect.top) * canvas.height / rect.height,
            };
        },
        startDrawing(e) {
            this.isDrawing = true;
            const { x, y } = this.getPointer(e);
            this.lastX = x;
            this.lastY = y;
            e.preventDefault();
        },
        draw(e) {
            if (!this.isDrawing) return;
            const { x, y } = this.getPointer(e);
            this.ctx.beginPath();
            this.ctx.moveTo(this.lastX, this.lastY);
            this.ctx.lineTo(x, y);
            this.ctx.stroke();
            this.hasSignature = true;
            this.lastX = x;
            this.lastY = y;
            e.preventDefault();
        },
        stopDrawing(e) {
            this.isDrawing = false;
            if (this.hasSignature) {
                this.$emit('input', this.$refs.signatureCanvas.toDataURL("image/png"));
            }
            e.preventDefault();
        },
        clearSignature() {
            const canvas = this.$refs.signatureCanvas;
            this.ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.signatureData = null;
            this.hasSignature = false;
            this.$emit('input', null);
        },
        saveSignature() {
            const canvas = this.$refs.signatureCanvas;
            this.signatureData = canvas.toDataURL("image/png"); // base64 image
            alert("Signature saved!");
        },
    },
};
</script>

<style scoped>
.signature-wrapper {
  /* max-width: 600px; */
  margin: 0 auto;
}
canvas {
  width: 0;
  min-width: 0;
  height: 120px;
  cursor: crosshair;
}
</style>
